import { IconLoader } from '@ui/src';
import MessageItem from './message-item';
import { MessagesListTypes } from './types';
import ROUTES from '../routes';

import cn from './messages.module.css';

const MessagesList = ({
  messages,
  path,
  isLoading,
  userId,
  pagination,
  matchPath,
  nextChannelsLoading,
  getNextChannels,
  scrollRef,
  selectedUserId,
  sendMessage,
}: MessagesListTypes) => {
  const onScroll = (scrollTop: number) => {
    if (scrollRef && scrollRef.current) {
      const { scrollHeight, clientHeight } = scrollRef.current;

      if (
        pagination?.hasNextPage &&
        scrollTop >= scrollHeight - clientHeight - 15
      ) {
        getNextChannels(messages?.length?.toString() as string);
      }
    }
  };

  let content;

  if (isLoading && !nextChannelsLoading) {
    content = (
      <div className={cn.messagesListLoader}>
        <IconLoader />
      </div>
    );
  } else if (!isLoading && !messages?.length) {
    let messageType: string;

    if (
      path === ROUTES.MESSAGES_MAIN_UNREAD ||
      path === ROUTES.MESSAGES_REQUEST_UNREAD
    ) {
      messageType = 'Unread';
    } else if (
      path === ROUTES.MESSAGES_MAIN_IN_PROGRESS ||
      path === ROUTES.MESSAGES_REQUEST_IN_PROGRESS
    ) {
      messageType = 'In Progress';
    } else {
      messageType = 'Inactive';
    }

    content = (
      <div className={cn.noChats}>
        {selectedUserId
          ? 'There are no chats with such a customer'
          : `No ${messageType} chats yet`}
      </div>
    );
  } else {
    content = messages?.map((item) => (
      <MessageItem
        key={item.id}
        message={item}
        path={matchPath}
        userId={userId}
        sendMessage={sendMessage}
      />
    ));
  }

  return (
    <div
      className={cn.messagesList}
      ref={scrollRef}
      onScroll={(e: any) => onScroll(e.target.scrollTop)}
    >
      {content}
      {nextChannelsLoading && (
        <div className={cn.nextChannelsLoading}>
          <IconLoader />
        </div>
      )}
    </div>
  );
};

export default MessagesList;
